import { Component, ViewEncapsulation } from '@angular/core';
import { ToolingTaskUpsertModel } from '../../upsert-tooling-task-wizard.component';
import { RotecFormGroupConfigV2, FormsModuleV2 } from '@schenck/rotec-components';
import { ToolingStepBaseComponent } from '../tooling-step-base.component';

@Component({
  selector: 'ma-tooling-documents-step',
  templateUrl: './documents-step.component.html',
  styleUrls: ['./documents-step.component.less'],
  encapsulation: ViewEncapsulation.None,
  imports: [FormsModuleV2],
})
export class ToolingDocumentsStepComponent extends ToolingStepBaseComponent {
  public documentsFields: RotecFormGroupConfigV2<Pick<ToolingTaskUpsertModel, 'documentIds'>> = [
    {
      key: 'documentIds',
      type: 'documents-v2',
      props: {
        maximumFileSizeInMb: 30,
        showSearch: true,
        hideFilterButton: true,
      },
    },
  ];
}
